import React from 'react';

import LandingPage from './pages/landing-page/landing-page';
import TestDownload from './pages/test-download/test-download';
import TestStuff from './pages/test-stuff/test-stuff';

function App() {
  return (
    <div>
      <LandingPage />
      {/* <TestDownload></TestDownload>
      <TestStuff></TestStuff> */}
    </div>
  );
}

export default App;
